<template>
  <div>
    <div class="contact-bg font1 bggreen3 position-relative">
      <!-- <Preload /> -->
      <div class="container pt-5 overflow-hidden">
        <!-- fake div and h1 tag -->

        <div class="mob-off-set-space fw-bold">
          <h1
            class="contact-head-font-size fw-bold reduce-title-font-size text-center"
          >
            I am just a message away
          </h1>
        </div>

        <div class="overbg font1">
          <form
            action="https://formbold.com/s/oWgwp"
            method="POST"
            class="z-content"
          >
            <!-- name -->
            <div
              class="d-flex off-felx-mob align-items-center justify-content-center z-content"
            >
              <div
                class="mb-4 mx-1 position-relative input-width w-35 z-content"
              >
                <!-- <label for="">Enter your name</label> -->
                <br />
                <div class="userpostion z-content">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="30px"
                    fill="white"
                    viewBox="0 0 480.804 480.804"
                    style="enable-background: new 0 0 480.804 480.804"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <g>
                          <path
                            d="M338.352,356.372c-0.984-0.536-3.118-1.704-6.024-3.334c-9.496-5.245-17.814-10.355-24.29-14.864
				c8.672,2.382,17.518,4.563,24.242,0.707c7.472-4.357,8.972-13.854,10.295-22.233c0.563-3.559,1.608-10.182,2.942-11.395
				c1.46-1.165,8.221-1.038,11.858-0.968c8.451,0.156,18.038,0.341,23.575-6.266c5.532-6.603,3.69-16.009,2.065-24.307
				c-0.701-3.583-2.007-10.251-1.146-11.813c1.021-1.555,7.329-3.721,10.718-4.885c8.067-2.771,17.212-5.911,20.146-14.005
				c2.966-7.999-1.957-16.164-6.302-23.367c-1.91-3.169-5.468-9.068-5.143-10.95c0.439-1.776,5.53-5.898,8.266-8.112
				c6.631-5.368,14.146-11.452,14.146-20.178c0-8.726-7.516-14.81-14.146-20.178c-2.735-2.214-7.826-6.336-8.269-8.13
				c-0.321-1.85,3.221-7.711,5.124-10.859c4.353-7.201,9.285-15.363,6.342-23.39c-2.949-8.133-12.06-11.246-20.098-13.993
				c-3.413-1.166-9.765-3.337-10.758-4.9c-0.869-1.655,0.424-8.259,1.119-11.807c1.628-8.314,3.473-17.739-2.065-24.261
				c-5.537-6.606-15.117-6.421-23.575-6.265c-3.636,0.069-10.398,0.196-11.815-0.931c-1.383-1.265-2.423-7.932-2.981-11.514
				c-1.306-8.374-2.786-17.865-10.222-22.165c-7.401-4.281-16.301-0.871-24.154,2.137c-3.428,1.313-9.8,3.748-11.577,3.13
				l-0.102-0.037c-1.701-0.715-4.906-6.529-6.628-9.652c-4.097-7.433-8.74-15.857-17.336-17.379
				c-8.359-1.431-15.515,4.809-21.822,10.308c-2.801,2.441-8.014,6.986-9.936,6.986c-1.929,0-7.15-4.563-9.955-7.013
				c-6.28-5.487-13.401-11.706-21.752-10.271c-8.532,1.511-13.207,9.928-17.331,17.354c-1.738,3.129-4.973,8.955-6.717,9.68
				c-1.766,0.623-8.116-1.811-11.528-3.116c-7.854-3.006-16.755-6.413-24.136-2.145c-7.516,4.294-8.997,13.792-10.304,22.172
				c-0.559,3.583-1.6,10.253-2.978,11.479c-1.489,1.118-8.169,1.002-11.758,0.941c-8.507-0.149-18.145-0.314-23.695,6.311
				c-5.456,6.529-3.642,15.875-2.041,24.121c0.7,3.606,2.004,10.321,1.105,11.93c-0.989,1.574-7.34,3.749-10.751,4.917
				c-8,2.739-17.068,5.845-20.083,13.916l-0.041,0.112c-2.845,8.002,2.044,16.122,6.357,23.286
				c1.906,3.165,5.454,9.057,5.121,10.937c-0.439,1.776-5.53,5.898-8.265,8.112c-6.631,5.368-14.147,11.452-14.147,20.178
				c0,8.726,7.516,14.81,14.147,20.178c2.735,2.214,7.826,6.336,8.268,8.13c0.332,1.875-3.231,7.806-5.146,10.992
				c-4.305,7.166-9.185,15.289-6.295,23.325c3.016,8.072,12.084,11.178,20.085,13.917c3.411,1.168,9.761,3.343,10.729,4.879
				c0.919,1.644-0.382,8.359-1.082,11.968c-1.6,8.253-3.413,17.608,2.007,24.182l0.07,0.084c5.519,6.498,15.05,6.338,23.463,6.193
				c3.656-0.063,10.473-0.178,11.936,1.001c1.395,1.229,2.436,7.889,2.995,11.468c1.305,8.348,2.783,17.811,10.327,22.21
				c2.643,1.496,5.576,2.069,8.676,2.069c4.563,0,9.488-1.243,14.376-2.612c-6.437,4.461-14.653,9.499-24.025,14.676
				c-2.889,1.62-5.021,2.787-5.997,3.317c-97.431,31.631-99.493,89.354-99.533,91.801l-0.001,32.623h395v-32.542
				C437.888,445.799,436.443,387.713,338.352,356.372z M170.374,323.386c-4.008,1.141-11.429,3.251-13.498,2.521
				c-1.391-1.352-2.42-7.94-2.978-11.504c-1.219-7.804-2.48-15.873-8.18-20.648c-5.7-4.775-13.9-4.638-21.825-4.501
				c-3.53,0.057-10.018,0.17-11.717-0.888c-0.754-1.856,0.484-8.245,1.158-11.72c1.507-7.774,3.065-15.814-0.64-22.298
				c-3.701-6.398-11.414-9.04-18.874-11.594c-3.393-1.162-9.632-3.299-10.835-4.909c-0.026-1.98,3.257-7.445,5.043-10.418
				c4.114-6.849,8.368-13.93,7.064-21.296c-1.238-7.196-7.526-12.287-13.606-17.209c-2.866-2.32-8.178-6.621-8.578-8.52
				c0.4-1.898,5.712-6.199,8.578-8.52c6.081-4.922,12.369-10.013,13.6-17.173c1.31-7.397-2.937-14.45-7.043-21.271
				c-1.802-2.993-5.117-8.499-5.059-10.477c1.2-1.61,7.441-3.747,10.834-4.909c7.46-2.555,15.174-5.196,18.894-11.629
				c3.688-6.454,2.127-14.493,0.618-22.269c-0.671-3.456-1.909-9.831-1.153-11.638c1.646-1.114,8.301-0.997,11.904-0.938
				c7.869,0.138,16.005,0.277,21.637-4.429c5.699-4.775,6.96-12.859,8.179-20.677c0.556-3.567,1.589-10.188,2.932-11.454
				c1.849-0.508,8.002,1.853,11.326,3.124c7.379,2.825,15.012,5.745,21.959,3.225c6.965-2.477,10.929-9.613,14.761-16.515
				c1.753-3.156,4.983-8.973,6.781-9.833c1.929,0.306,6.719,4.491,9.32,6.764c6.03,5.27,12.266,10.718,19.825,10.718
				c7.543,0,13.771-5.43,19.793-10.681c2.64-2.301,7.504-6.542,9.442-6.804c1.785,0.853,4.986,6.66,6.723,9.811
				c3.8,6.895,7.729,14.022,14.676,16.521c7.024,2.591,14.704-0.351,22.132-3.195c3.295-1.262,9.363-3.589,11.271-3.143
				c1.354,1.439,2.369,7.947,2.919,11.475c1.217,7.799,2.475,15.862,8.128,20.664c5.695,4.771,13.872,4.618,21.774,4.466
				c3.608-0.065,10.287-0.193,11.789,0.912c0.799,1.765-0.469,8.235-1.153,11.733c-1.52,7.762-3.091,15.787,0.613,22.193
				c3.7,6.398,11.425,9.038,18.896,11.591c3.436,1.174,9.808,3.352,10.833,4.9c0.146,1.908-3.236,7.504-5.064,10.529
				c-4.112,6.805-8.365,13.842-7.063,21.197c1.238,7.196,7.525,12.287,13.606,17.209c2.866,2.32,8.179,6.621,8.578,8.52
				c-0.399,1.898-5.712,6.199-8.578,8.52c-6.081,4.922-12.368,10.013-13.6,17.173c-1.311,7.396,2.95,14.461,7.07,21.294
				c1.806,2.994,5.14,8.523,5.051,10.453c-1.122,1.62-7.482,3.805-10.923,4.986c-7.423,2.549-15.099,5.185-18.825,11.554
				c-3.682,6.443-2.112,14.46-0.595,22.213c0.688,3.516,1.96,10.01,1.146,11.78c-1.603,1.105-8.209,0.982-11.783,0.912
				c-7.899-0.145-16.079-0.304-21.812,4.499c-5.599,4.754-6.864,12.77-8.089,20.521c-0.57,3.612-1.627,10.305-2.995,11.581
				c-2.193,0.73-9.844-1.375-13.978-2.515c-4.472-1.235-8.809-2.425-12.884-2.916v-14.502c17.821-10.189,32.66-25.407,43.089-44.27
				c11.063-20.011,16.911-43.655,16.911-68.379v-62.5h-7.5c-62.284,0-110.194-33.288-110.664-33.62l-11.836-8.385v14.505
				c0,6.053-12.156,14.843-46.272,21.357c-25.436,4.857-51.327,6.139-51.585,6.151l-7.143,0.342v62.149
				c0,24.723,5.848,48.368,16.912,68.379c10.429,18.863,25.267,34.081,43.088,44.27v14.535
				C178.826,320.992,174.563,322.196,170.374,323.386z M240.402,305.803c-16.917,0-32.575-3.685-46.537-10.952l-0.023-0.013
				c-16.986-8.766-31.129-22.741-40.901-40.414c-9.838-17.795-15.039-38.93-15.039-61.121V145.34
				c9.708-0.716,27.939-2.402,46.403-5.92c29.784-5.673,48.007-13.803,55.14-24.678c16.324,9.64,54.907,29.057,103.457,30.916
				v47.645c0,22.191-5.2,43.326-15.038,61.121c-9.772,17.673-23.915,31.649-40.925,40.427
				C272.977,302.119,257.32,305.803,240.402,305.803z M282.902,313.102v17.312c-5.13,5.363-21.386,20.389-42.5,20.389
				c-20.977,0-37.346-15.055-42.5-20.404v-17.298c13.182,5.109,27.424,7.702,42.5,7.702
				C255.482,320.803,269.728,318.208,282.902,313.102z M190.14,343.835c8.644,8.14,26.783,21.968,50.261,21.968
				c23.48,0,41.618-13.828,50.261-21.968c6.842,5.72,16.102,11.675,24.212,16.493c-6.078,4.175-14.407,9.532-23.81,14.561
				c-19.464,10.411-36.983,15.914-50.662,15.914s-31.198-5.503-50.663-15.914c-9.442-5.05-17.691-10.341-23.82-14.556
				C174.04,355.509,183.301,349.554,190.14,343.835z M57.902,465.803v-17.409c0.056-1.515,2.773-49.93,89.799-77.952
				c0,0,2.243-1.067,3.81-1.929c6.486,4.725,17.691,12.403,31.154,19.604c18.684,9.994,35.536,15.776,50.237,17.277v42.909h15
				v-42.909c14.701-1.502,31.553-7.284,50.237-17.277c13.465-7.202,24.669-14.879,31.155-19.604c1.62,0.891,3.843,1.94,3.843,1.94
				c25.456,8.064,59.721,23.257,78.396,49.836c10.718,15.254,11.344,27.458,11.368,28.096v17.418H57.902z"
                          />
                          <path
                            d="M247.902,183.303h-15v40c0,4.143,3.358,7.5,7.5,7.5h20v-15h-12.5V183.303z"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <label for="name" class="fs-200 z-content">Name</label>
                <br />
                <input
                  type="text"
                  placeholder="Enter your name"
                  class="border-bottom z-content name py-3 px-5 input-width remove-input-defaults w-80 reduce-placeholder-font fs-400 border-0 w-90 border-2 border-light"
                  name="name"
                  required
                />
              </div>
              <!-- email adress -->
              <div class="my-4 position-relative input-width w-35 z-content">
                <div class="atpostion z-content">
                  <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="30px"
                    fill="white"
                    viewBox="0 0 205.996 205.996"
                    style="enable-background: new 0 0 205.996 205.996"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        d="M102.996,61.363c22.958,0,41.635,18.678,41.635,41.635c0,3.313,2.687,6,6,6s6-2.687,6-6
		c0-29.574-24.061-53.635-53.635-53.635S49.36,73.424,49.36,102.998s24.061,53.635,53.635,53.635
		c18.99,0,36.745-10.195,46.336-26.607c1.672-2.861,0.708-6.535-2.153-8.208c-2.86-1.67-6.535-0.707-8.208,2.153
		c-7.448,12.745-21.233,20.662-35.976,20.662c-22.958,0-41.635-18.678-41.635-41.635S80.038,61.363,102.996,61.363z"
                      />
                      <path
                        d="M205.698,95.053c-3.76-50.059-44.326-90.782-94.359-94.727C81.095-2.059,51.51,8.817,30.163,30.165
		C8.815,51.513-2.061,81.1,0.324,111.341c3.931,49.847,44.483,90.399,94.329,94.329c2.747,0.217,5.484,0.323,8.214,0.323
		c27.329,0,53.553-10.753,72.962-30.161c2.343-2.344,2.343-6.143,0-8.485s-6.142-2.344-8.485-0.001
		c-18.862,18.861-45.012,28.47-71.747,26.361c-44.023-3.471-79.838-39.286-83.31-83.31c-2.108-26.735,7.5-52.887,26.361-71.747
		c18.861-18.861,45.008-28.473,71.747-26.361c44.189,3.483,80.016,39.451,83.337,83.662c0.455,6.057,0.321,12.142-0.397,18.086
		c-0.762,6.304-4.578,11.805-10.208,14.713c-5.095,2.633-10.819,2.623-15.706-0.026c-2.913-1.582-6.556-0.499-8.134,2.415
		c-1.58,2.913-0.499,6.555,2.415,8.134c8.435,4.573,18.251,4.623,26.933,0.139c9.164-4.734,15.375-13.682,16.613-23.935
		C206.06,108.758,206.211,101.887,205.698,95.053z"
                      />
                    </g>
                  </svg>
                </div>
                <label for="email" class="fs-200 z-content"
                  >Email address</label
                >
                <br />
                <input
                  type="email"
                  placeholder="Enter your email address"
                  class="border-bottom w-100 fs-400 z-content white remove-input-defaults reduce-placeholder-font px-5 py-3 border-0 w-70 border-2 border-light"
                  name="email"
                  required
                />
              </div>
            </div>

            <!-- message -->
            <div
              class="my-4 w-70 input-width m-auto position-relative z-content"
            >
              <div class="atpostion">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="30px"
                  fill="white"
                  viewBox="0 0 480.804 480.804"
                  style="enable-background: new 0 0 480.804 480.804"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M338.352,356.372c-0.984-0.536-3.118-1.704-6.024-3.334c-9.496-5.245-17.814-10.355-24.29-14.864
				c8.672,2.382,17.518,4.563,24.242,0.707c7.472-4.357,8.972-13.854,10.295-22.233c0.563-3.559,1.608-10.182,2.942-11.395
				c1.46-1.165,8.221-1.038,11.858-0.968c8.451,0.156,18.038,0.341,23.575-6.266c5.532-6.603,3.69-16.009,2.065-24.307
				c-0.701-3.583-2.007-10.251-1.146-11.813c1.021-1.555,7.329-3.721,10.718-4.885c8.067-2.771,17.212-5.911,20.146-14.005
				c2.966-7.999-1.957-16.164-6.302-23.367c-1.91-3.169-5.468-9.068-5.143-10.95c0.439-1.776,5.53-5.898,8.266-8.112
				c6.631-5.368,14.146-11.452,14.146-20.178c0-8.726-7.516-14.81-14.146-20.178c-2.735-2.214-7.826-6.336-8.269-8.13
				c-0.321-1.85,3.221-7.711,5.124-10.859c4.353-7.201,9.285-15.363,6.342-23.39c-2.949-8.133-12.06-11.246-20.098-13.993
				c-3.413-1.166-9.765-3.337-10.758-4.9c-0.869-1.655,0.424-8.259,1.119-11.807c1.628-8.314,3.473-17.739-2.065-24.261
				c-5.537-6.606-15.117-6.421-23.575-6.265c-3.636,0.069-10.398,0.196-11.815-0.931c-1.383-1.265-2.423-7.932-2.981-11.514
				c-1.306-8.374-2.786-17.865-10.222-22.165c-7.401-4.281-16.301-0.871-24.154,2.137c-3.428,1.313-9.8,3.748-11.577,3.13
				l-0.102-0.037c-1.701-0.715-4.906-6.529-6.628-9.652c-4.097-7.433-8.74-15.857-17.336-17.379
				c-8.359-1.431-15.515,4.809-21.822,10.308c-2.801,2.441-8.014,6.986-9.936,6.986c-1.929,0-7.15-4.563-9.955-7.013
				c-6.28-5.487-13.401-11.706-21.752-10.271c-8.532,1.511-13.207,9.928-17.331,17.354c-1.738,3.129-4.973,8.955-6.717,9.68
				c-1.766,0.623-8.116-1.811-11.528-3.116c-7.854-3.006-16.755-6.413-24.136-2.145c-7.516,4.294-8.997,13.792-10.304,22.172
				c-0.559,3.583-1.6,10.253-2.978,11.479c-1.489,1.118-8.169,1.002-11.758,0.941c-8.507-0.149-18.145-0.314-23.695,6.311
				c-5.456,6.529-3.642,15.875-2.041,24.121c0.7,3.606,2.004,10.321,1.105,11.93c-0.989,1.574-7.34,3.749-10.751,4.917
				c-8,2.739-17.068,5.845-20.083,13.916l-0.041,0.112c-2.845,8.002,2.044,16.122,6.357,23.286
				c1.906,3.165,5.454,9.057,5.121,10.937c-0.439,1.776-5.53,5.898-8.265,8.112c-6.631,5.368-14.147,11.452-14.147,20.178
				c0,8.726,7.516,14.81,14.147,20.178c2.735,2.214,7.826,6.336,8.268,8.13c0.332,1.875-3.231,7.806-5.146,10.992
				c-4.305,7.166-9.185,15.289-6.295,23.325c3.016,8.072,12.084,11.178,20.085,13.917c3.411,1.168,9.761,3.343,10.729,4.879
				c0.919,1.644-0.382,8.359-1.082,11.968c-1.6,8.253-3.413,17.608,2.007,24.182l0.07,0.084c5.519,6.498,15.05,6.338,23.463,6.193
				c3.656-0.063,10.473-0.178,11.936,1.001c1.395,1.229,2.436,7.889,2.995,11.468c1.305,8.348,2.783,17.811,10.327,22.21
				c2.643,1.496,5.576,2.069,8.676,2.069c4.563,0,9.488-1.243,14.376-2.612c-6.437,4.461-14.653,9.499-24.025,14.676
				c-2.889,1.62-5.021,2.787-5.997,3.317c-97.431,31.631-99.493,89.354-99.533,91.801l-0.001,32.623h395v-32.542
				C437.888,445.799,436.443,387.713,338.352,356.372z M170.374,323.386c-4.008,1.141-11.429,3.251-13.498,2.521
				c-1.391-1.352-2.42-7.94-2.978-11.504c-1.219-7.804-2.48-15.873-8.18-20.648c-5.7-4.775-13.9-4.638-21.825-4.501
				c-3.53,0.057-10.018,0.17-11.717-0.888c-0.754-1.856,0.484-8.245,1.158-11.72c1.507-7.774,3.065-15.814-0.64-22.298
				c-3.701-6.398-11.414-9.04-18.874-11.594c-3.393-1.162-9.632-3.299-10.835-4.909c-0.026-1.98,3.257-7.445,5.043-10.418
				c4.114-6.849,8.368-13.93,7.064-21.296c-1.238-7.196-7.526-12.287-13.606-17.209c-2.866-2.32-8.178-6.621-8.578-8.52
				c0.4-1.898,5.712-6.199,8.578-8.52c6.081-4.922,12.369-10.013,13.6-17.173c1.31-7.397-2.937-14.45-7.043-21.271
				c-1.802-2.993-5.117-8.499-5.059-10.477c1.2-1.61,7.441-3.747,10.834-4.909c7.46-2.555,15.174-5.196,18.894-11.629
				c3.688-6.454,2.127-14.493,0.618-22.269c-0.671-3.456-1.909-9.831-1.153-11.638c1.646-1.114,8.301-0.997,11.904-0.938
				c7.869,0.138,16.005,0.277,21.637-4.429c5.699-4.775,6.96-12.859,8.179-20.677c0.556-3.567,1.589-10.188,2.932-11.454
				c1.849-0.508,8.002,1.853,11.326,3.124c7.379,2.825,15.012,5.745,21.959,3.225c6.965-2.477,10.929-9.613,14.761-16.515
				c1.753-3.156,4.983-8.973,6.781-9.833c1.929,0.306,6.719,4.491,9.32,6.764c6.03,5.27,12.266,10.718,19.825,10.718
				c7.543,0,13.771-5.43,19.793-10.681c2.64-2.301,7.504-6.542,9.442-6.804c1.785,0.853,4.986,6.66,6.723,9.811
				c3.8,6.895,7.729,14.022,14.676,16.521c7.024,2.591,14.704-0.351,22.132-3.195c3.295-1.262,9.363-3.589,11.271-3.143
				c1.354,1.439,2.369,7.947,2.919,11.475c1.217,7.799,2.475,15.862,8.128,20.664c5.695,4.771,13.872,4.618,21.774,4.466
				c3.608-0.065,10.287-0.193,11.789,0.912c0.799,1.765-0.469,8.235-1.153,11.733c-1.52,7.762-3.091,15.787,0.613,22.193
				c3.7,6.398,11.425,9.038,18.896,11.591c3.436,1.174,9.808,3.352,10.833,4.9c0.146,1.908-3.236,7.504-5.064,10.529
				c-4.112,6.805-8.365,13.842-7.063,21.197c1.238,7.196,7.525,12.287,13.606,17.209c2.866,2.32,8.179,6.621,8.578,8.52
				c-0.399,1.898-5.712,6.199-8.578,8.52c-6.081,4.922-12.368,10.013-13.6,17.173c-1.311,7.396,2.95,14.461,7.07,21.294
				c1.806,2.994,5.14,8.523,5.051,10.453c-1.122,1.62-7.482,3.805-10.923,4.986c-7.423,2.549-15.099,5.185-18.825,11.554
				c-3.682,6.443-2.112,14.46-0.595,22.213c0.688,3.516,1.96,10.01,1.146,11.78c-1.603,1.105-8.209,0.982-11.783,0.912
				c-7.899-0.145-16.079-0.304-21.812,4.499c-5.599,4.754-6.864,12.77-8.089,20.521c-0.57,3.612-1.627,10.305-2.995,11.581
				c-2.193,0.73-9.844-1.375-13.978-2.515c-4.472-1.235-8.809-2.425-12.884-2.916v-14.502c17.821-10.189,32.66-25.407,43.089-44.27
				c11.063-20.011,16.911-43.655,16.911-68.379v-62.5h-7.5c-62.284,0-110.194-33.288-110.664-33.62l-11.836-8.385v14.505
				c0,6.053-12.156,14.843-46.272,21.357c-25.436,4.857-51.327,6.139-51.585,6.151l-7.143,0.342v62.149
				c0,24.723,5.848,48.368,16.912,68.379c10.429,18.863,25.267,34.081,43.088,44.27v14.535
				C178.826,320.992,174.563,322.196,170.374,323.386z M240.402,305.803c-16.917,0-32.575-3.685-46.537-10.952l-0.023-0.013
				c-16.986-8.766-31.129-22.741-40.901-40.414c-9.838-17.795-15.039-38.93-15.039-61.121V145.34
				c9.708-0.716,27.939-2.402,46.403-5.92c29.784-5.673,48.007-13.803,55.14-24.678c16.324,9.64,54.907,29.057,103.457,30.916
				v47.645c0,22.191-5.2,43.326-15.038,61.121c-9.772,17.673-23.915,31.649-40.925,40.427
				C272.977,302.119,257.32,305.803,240.402,305.803z M282.902,313.102v17.312c-5.13,5.363-21.386,20.389-42.5,20.389
				c-20.977,0-37.346-15.055-42.5-20.404v-17.298c13.182,5.109,27.424,7.702,42.5,7.702
				C255.482,320.803,269.728,318.208,282.902,313.102z M190.14,343.835c8.644,8.14,26.783,21.968,50.261,21.968
				c23.48,0,41.618-13.828,50.261-21.968c6.842,5.72,16.102,11.675,24.212,16.493c-6.078,4.175-14.407,9.532-23.81,14.561
				c-19.464,10.411-36.983,15.914-50.662,15.914s-31.198-5.503-50.663-15.914c-9.442-5.05-17.691-10.341-23.82-14.556
				C174.04,355.509,183.301,349.554,190.14,343.835z M57.902,465.803v-17.409c0.056-1.515,2.773-49.93,89.799-77.952
				c0,0,2.243-1.067,3.81-1.929c6.486,4.725,17.691,12.403,31.154,19.604c18.684,9.994,35.536,15.776,50.237,17.277v42.909h15
				v-42.909c14.701-1.502,31.553-7.284,50.237-17.277c13.465-7.202,24.669-14.879,31.155-19.604c1.62,0.891,3.843,1.94,3.843,1.94
				c25.456,8.064,59.721,23.257,78.396,49.836c10.718,15.254,11.344,27.458,11.368,28.096v17.418H57.902z"
                        />
                        <path
                          d="M247.902,183.303h-15v40c0,4.143,3.358,7.5,7.5,7.5h20v-15h-12.5V183.303z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <label for="message" class="fs-200 z-content">Your message</label>
              <br />
              <textarea
                type="text"
                name="message"
                placeholder="What do you have in mind"
                class="border-bottom z-content white py-3 fs-400 overflow-auto reduce-placeholder-font remove-input-defaults px-5 border-0 w-100 border-2 border-light"
              />
            </div>
            <!-- lets talk button -->
            <div class="z-content">
              <div class="d-flex justify-content-center">
                <button type="submit" class="contact-button py-2 z-content">
                  <div class="">
                    <span class="bg"></span>
                    <span class="base"></span>
                    <span class="text fw-bold"> Contact me </span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="">
          <h1
            style="font-size: 22em"
            class="bgContact bgfont text-center fontneubold"
          >
            Contact
          </h1>
        </div>
      </div>
      <!-- fp -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => {
    return {
      typeValue: "",
      typeStatus: false,
      typeArray: [
        "Lets Build",
        "Lets talk about the future",
        "of your next project",
        "Reach Out :)",
      ],
      typingSpeed: 150,
      erasingSpeed: 50,
      newTextDelay: 1500,
      typeArrayIndex: 0,
      charIndex: 0,
    };
  },
  methods: {
    typeText() {
      if (this.charIndex < this.typeArray[this.typeArrayIndex].length) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue += this.typeArray[this.typeArrayIndex].charAt(
          this.charIndex
        );
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      } else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },
    eraseText() {
      if (this.charIndex > 0) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue = this.typeArray[this.typeArrayIndex].substring(
          0,
          this.charIndex - 1
        );
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      } else {
        this.typeStatus = false;
        this.typeArrayIndex += 1;
        if (this.typeArrayIndex >= this.typeArray.length)
          this.typeArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    },
  },
  created() {
    setTimeout(this.typeText, this.newTextDelay + 200);
  },
};
</script>

<style scoped>
.z-content {
  z-index: 9999 !important ;
}
/*put form over background text */
.overbg {
  z-index: 30000;
}
button {
  background-color: transparent;
  border: none;
}
/* background text */
.bgContact {
  color: rgba(105, 105, 105, 0.199) !important;
  position: absolute;
  z-index: 0 !important;
  /* top: 0; */
  /* left: 0; */
  bottom: 0rem;
}
/* .bgContactheight{
  height:10vh !important;
} */
/* projects button */
.contact-button {
  text-decoration: none;
  width: 50%;
  /* max-width: 200px; */
  height: 70px;
  display: block;
  line-height: 50px;
  /* letter-spacing: 3px; */
  position: relative;
  text-align: center;
  color: #08fdd8;
  /* margin-top: 50px; */
}
.contact-button div {
  position: relative;
  top: 0rem !important;
  /* left: -3.5rem; */
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}
.contact-button span.bg {
  position: absolute;
  width: 0%;
  height: 100%;
  left: -5px;
  top: 0;
  transition: all 0.3s ease-in-out;
  background-color: #06d599;
  transform: skewX(-19deg);
}
.contact-button:hover span.bg {
  width: 110%;
}
.contact-button span.base {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  border: 2px solid #06d599;
  box-sizing: border-box;
}
.contact-button span.text {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  color: white;
  left: 0;
}
.contact-button:hover span.text {
  color: #162120;
}
.text-contact {
  font-weight: 900 !important;
  font-size: 4.3rem;
}
.contacts-marg {
  margin: 1.5rem 3.5rem !important ;
}
/* @position */
.atpostion {
  position: absolute !important;
  top: 2.6rem;
  bottom: 2rem !important;
}
/* second at position */
.at2postion {
  position: absolute;
  top: -6rem;
  bottom: 0rem;
  z-index: -1;
}
.userpostion {
  position: absolute !important;
  top: 4rem;
  bottom: 2rem !important;
}
/* send button */
.intro-marg-button {
  margin: 2rem 0rem 3.5rem 3.5rem !important ;
  position: absolute;
  top: -7rem;
  bottom: 0;
  left: 30rem;
  right: 0;
  z-index: 10;
}

/* background color */
.contact-bg {
  /* background-color: rgb(235, 235, 235); */
  /* background-image: url(@/assets/icon/at2.png) !important; */
  background-size: contain;
  background-repeat: no-repeat;
  color: white;
  height: 100%;
  padding: 4rem 0rem;
}
/* project header */
.contact-head-font-size {
  font-size: 4rem !important;
  color: #06d599 !important;
}
.bord-contacts-button {
  border: 2px solid var(--clr-green) !important;
}
/* remove input default style */
.remove-input-defaults {
  background: transparent !important;
}
.remove-input-defaults::placeholder {
  color: white !important;
}
/* remove focus */
input:focus {
  outline: none !important;
  color: white !important;
}
textarea:focus {
  outline: none !important;
  color: white !important;
}
.mob-width {
  max-width: 95%;
  margin: auto;
}
@media (min-width: 1410px) {
  .mob-width {
    max-width: 1250px !important;
  }
  .max2 {
    max-width: 100% !important;
  }
}

@media (max-width: 768px) {
  .reduce-placeholder-font {
    font-size: 1rem !important;
  }
  /* title */
  .reduce-title-font-size {
    font-size: 2.5rem !important;
    padding: 0rem 1.4rem !important;
  }
  .mob-off-set-space {
    padding: 0rem !important;
    margin: unset !important;
  }
  .mob-width {
    width: 100%;
  }
  .input-width {
    width: 100% !important;
  }
  .contact-bg {
    padding: 1rem 0rem !important;
  }
  .off-felx-mob {
    display: block !important;
  }
  /* remove input default style */
  .remove-input-defaults {
    background: var(--clr-bgwhite1) !important;
  }
  /* projects button */
  .contact-button {
    text-decoration: none;
    width: 100%;
    /* max-width: 200px; */
    height: 70px;
    display: block;
    line-height: 50px;
    /* letter-spacing: 3px; */
    position: relative;
    text-align: center;
    color: #08fdd8;
    /* margin-top: 50px; */
  }
}
@media (max-width: 576px) {
  .not-on-mobile {
    display: none !important;
  }
  /* title */
  .reduce-title-font-size {
    font-size: 2rem !important;
    padding: 0rem 1.4rem !important;
  }
}
/* @media (min-width: 1199px) {
 .bgfont{
    font-size: 20em;
  }
} */
@media (max-width: 1197px) {
  .bgfont {
    font-size: 25vw !important;
  }
}

/* .bgfont{
    font-size: 20em;
  } */
</style>
